
import React from 'react';
import ArticleCard from './shared/ArticleCard';
import EmptyState from './shared/EmptyState';
import { Article } from '@/hooks/journalist/types';

interface ArticleTabProps {
  articles: Article[];
}

const ArticleTab: React.FC<ArticleTabProps> = ({ articles }) => {
  // Only show the featured articles (or first 4 if none are marked as featured)
  const featuredArticles = articles.filter(article => article.featured)
    .slice(0, 4);
  
  // If no articles are featured, show first 4 of all articles
  const displayedArticles = featuredArticles.length > 0 ? 
    featuredArticles : articles.slice(0, 4);
  
  return (
    <>
      <h2 className="text-2xl font-bold mb-6">Featured Articles</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {displayedArticles.length > 0 ? (
          displayedArticles.map(article => (
            <ArticleCard 
              key={article.id} 
              article={article}
              showLead={true}
            />
          ))
        ) : (
          <EmptyState 
            message="No articles found for this journalist." 
            showDefaultAction={true}
          />
        )}
      </div>
    </>
  );
};

export default ArticleTab;
